import { useEffect } from 'react';

import { ShortcutContext, ShortcutKey } from './types';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

interface UseInboxTabNavigationProps {
  activeTabIndex: number;
  onTabChange: (index: number) => void;
  totalTabs: number;
}

export function useInboxTabNavigation({
  activeTabIndex,
  onTabChange,
  totalTabs,
}: UseInboxTabNavigationProps) {
  const { registerShortcut, unregisterShortcut } = useKeyboardShortcuts();

  useEffect(() => {
    registerShortcut({
      key: ShortcutKey.ARROW_LEFT,
      contexts: [ShortcutContext.INBOX_LIST],
      handler: () => {
        const newIndex =
          activeTabIndex > 0 ? activeTabIndex - 1 : totalTabs - 1;
        onTabChange(newIndex);
      },
      description: 'Move to previous tab',
    });

    registerShortcut({
      key: ShortcutKey.ARROW_RIGHT,
      contexts: [ShortcutContext.INBOX_LIST],
      handler: () => {
        const newIndex =
          activeTabIndex < totalTabs - 1 ? activeTabIndex + 1 : 0;
        onTabChange(newIndex);
      },
      description: 'Move to next tab',
    });

    return () => {
      const ctx = [ShortcutContext.INBOX_LIST];
      unregisterShortcut(ShortcutKey.ARROW_LEFT, ctx);
      unregisterShortcut(ShortcutKey.ARROW_RIGHT, ctx);
    };
  }, [
    registerShortcut,
    unregisterShortcut,
    activeTabIndex,
    onTabChange,
    totalTabs,
  ]);
}
